import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";

// import "./organiserDetails.css";
import OrganiserDetailsComponent from "./organiserDetailsComponent";

import useWindowDimension from "../../../components/hooks/useWindowDimension";

import { showToast } from "../../../store/features/toast/toastSlice";

import {
  currentEventOfOrganiserAction,
  pastEventOfOrganiserAction,
  activeInactiveOrganiserAction,
  deleteOrganiserAction,
} from "../../../store/features/organiser/organiserSlice";
import useAuth from "../../../hooks/useAuth";

const OrganiserDetailsContainer = ({ props }) => {
  const { isAdmin } = useAuth();

  const {
    currentEventsOfOrganiser,

    pastEventsOfOrganiser,
  } = useSelector((state) => state?.organiser);
  /**
   * Initializes various variables and hooks for the component.
   * @returns None
   */
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pageSizeRef = useRef(4);
  const smarttableref = useRef();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const tableContainerRef = useRef(null);
  const dimensions = useWindowDimension();
  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const closeDeleteUserModal = () => setshowDeleteUserModal(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [isCheckSwitch, setIsCheckSwitch] = useState(true);
  const [loading, setLoading] = useState(false);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [searchValue, setSearchValue] = useState(null);
  const [showViewTicketModal, setShowViewTicketModal] = useState(false);

  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [userContentHeight, setUserContentHeight] = useState("");
  const [tabHeight, setTabHeight] = useState("");
  const [currentOrganiser, setCurrentOrganiser] = useState("");
  const [deleteOrganiser, setDeleteOrganiser] = useState("");

  /**
   * Executes a side effect after the component has rendered.
   * The side effect sets the `placeHolder` state to `false` after a delay of 2000 milliseconds.
   * @returns None
   */
  useEffect(() => {
    setTimeout(() => {
      setPlaceHolder(false);
    }, 2000);
  });
  const organiser = state?.itemData || null;

  useEffect(() => {
    isAdmin
      ? dispatch(currentEventOfOrganiserAction(organiser._id))
      : dispatch(currentEventOfOrganiserAction());

    isAdmin
      ? dispatch(pastEventOfOrganiserAction(organiser._id))
      : dispatch(pastEventOfOrganiserAction());
  }, [isAdmin, organiser._id, dispatch]);
  /**
   * Opens the delete user modal for the specified item.
   * @param {{Event}} e - The event object.
   * @param {{any}} item - The item to be deleted.
   * @returns None
   */
  const openDeleteUserModal = (e, item) => {
    setDeleteOrganiser(item);
    setshowDeleteUserModal(true);
  };

  /**
   * Loads more items when triggered, with a delay of 2000 milliseconds.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight;

      if (isAtBottom && pastEventsOfOrganiser.length > pageSizeRef.current) {
        loadMoreItems();
      }
      if (isAtBottom && currentEventsOfOrganiser.length > pageSizeRef.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * Updates the heights of various elements on the page when the loading state changes.
   * @param {{boolean}} loading - The loading state of the page.
   * @returns None
   */

  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("table-responsive")[0].offsetHeight
      );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
    setUserContentHeight(
      document.getElementsByClassName("userContaint")[0].offsetHeight
    );
    setTabHeight(
      document.getElementsByClassName("user-details-tabs")[0].offsetHeight
    );
  }, [loading]);

  /**
   * Navigates to the "/user-mangment" page.
   * @returns None
   */
  const backPageFunction = () => {
    navigate("/users-management");
  };

  /**
   * An array of column objects used for displaying a table.
   * Each column object contains a label, key, filter function, and sorting flag.
   * @type {Array}
   */
  const currentEventColumns = [
    {
      label: (
        <>
          {t("EVENT_DETAILS")}{" "}
          <span className="thCount">
            {currentEventsOfOrganiser.length
              ? currentEventsOfOrganiser.length
              : 0}
          </span>
        </>
      ),
      key: "title",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("EVENT_TIMINGS")}</>,
      key: "eventTimings",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("ARTIST")}</>,
      key: "artist",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("TYPE")}</>,
      key: "category",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("EVENT_STATUS")}</>,
      key: "eventstatus",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("TICKET_PRICE")}</>,
      filter: false,
      key: "ticketPrice",
      sorting: false,
    },
    {
      label: <>{t("TICKETS_SOLD")}</>,
      key: "ticketssold",
      filter: false,
      sorting: false,
    },
  ];
  const pastEventColumns = [
    {
      label: (
        <>
          {t("EVENT_DETAILS")}{" "}
          <span className="thCount">
            {" "}
            {pastEventsOfOrganiser.length ? pastEventsOfOrganiser.length : 0}
          </span>
        </>
      ),
      key: "title",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("ARTIST")}</>,
      key: "artist",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("TYPE")}</>,
      key: "category",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("EVENT_TIMINGS")}</>,
      key: "eventTimings",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("EVENT_STATUS")}</>,
      key: "eventstatus",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("TICKET_PRICE")}</>,
      filter: false,
      key: "ticketPrice",
      sorting: false,
    },
    {
      label: <>{t("TICKETS_SOLD")}</>,
      key: "ticketssold",
      filter: false,
      sorting: false,
    },
  ];

  // If screen width is less than 1440, remove the specified column

  const pageTitle = [
    {
      title: "Users",
    },
    {
      title: "Users",
    },
  ];
  const openExportModal = () => {
    setTimeout(() => {
      dispatch(
        showToast({
          message: t("USER_HAS_BEEN_EXPORTED_SUCCESSFULLY"),
          type: "success",
        })
      );
      navigate("/users-management");
    }, 1500);
  };

  /**
   * Executes a series of actions when a user is deleted.
   * - Displays a success toast message.
   * - Closes the delete user modal.
   * @returns None
   */
  const onDeleteUser = () => {
    dispatch(deleteOrganiserAction(deleteOrganiser?._id)).then(
      (resultAction) => {
        if (deleteOrganiserAction.fulfilled.match(resultAction)) {
          navigate(-1);
          setTimeout(() => {
            dispatch(
              showToast({
                show: false,
                message: resultAction?.payload?.message,
                type: "success",
              })
            );
            closeDeleteUserModal();
          });
        } else if (deleteOrganiserAction.rejected.match(resultAction)) {
          setTimeout(() => {
            dispatch(
              showToast({
                show: false,
                message: resultAction?.error?.message,
                type: "error",
              })
            );
            closeDeleteUserModal();
          });
        }
      }
    );
  };

  /**
   * Displays a toast notification indicating that a download was successful.
   * @returns None
   */
  const downloadUserValue = () => {
    dispatch(
      showToast({
        message: t("DOWNLOADED_SUCCESSFULLY"),
        type: "success",
      })
    );
  };

  const onCheckAction = (e, organiser) => {
    if (isCheckSwitch) {
      setCurrentOrganiser(organiser);
      setShowStatusModal(true);
    } else {
      unableAction(e, organiser._id);
    }
  };

  /**
   * Function to handle the proceed action after a certain event.
   * It sets the value of isCheckSwitch to false and showStatusModal to false.
   * It then dispatches a showToast action with a success message.
   * Finally, it closes the deleteUserModal after a delay of 1000 milliseconds.
   * @returns None
   */
  const onProcced = (e) => {
    const data = { _id: currentOrganiser._id, status: "deactive" };
    dispatch(activeInactiveOrganiserAction(data)).then((resultAction) => {
      if (activeInactiveOrganiserAction.fulfilled.match(resultAction)) {
        setIsCheckSwitch(false);
        setShowStatusModal(false);
        setTimeout(() => {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.payload?.res?.message,
              type: "success",
            })
          );
          closeDeleteUserModal();
        }, 1000);
      } else if (activeInactiveOrganiserAction.rejected.match(resultAction)) {
        closeDeleteUserModal();

        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };

  /**
   * Handles an unable action event.
   * @param {{Event}} e - The event object.
   * @param {{string}} id - The ID of the action.
   * @returns None
   */
  const unableAction = (e, id) => {
    const data = { _id: id, status: "active" };

    dispatch(activeInactiveOrganiserAction(data)).then((resultAction) => {
      if (activeInactiveOrganiserAction.fulfilled.match(resultAction)) {
        setIsCheckSwitch(true);
        setTimeout(() => {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.payload?.res?.message,
              type: "success",
            })
          );
          closeDeleteUserModal();
        }, 1000);
      } else if (activeInactiveOrganiserAction.rejected.match(resultAction)) {
        closeDeleteUserModal();

        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };

  /**
   * Clears the search input field by programmatically clicking the first button element
   * within the smart table component.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  const onTableFilterChange = (filterText) => {
    setSearchValue(filterText);
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  const editUserFun = () => {
    navigate("/user-managment", {
      state: {
        state,
      },
    });
  };

  const closeDeactivateModal = () => setShowStatusModal(false);

  const closeViewTicketModal = () => setShowViewTicketModal(false);
  const openviewTicketModal = (e, item) => {
    setShowViewTicketModal(true);
  };

  return (
    <OrganiserDetailsComponent
      backPageFunction={backPageFunction}
      currentEventColumns={currentEventColumns}
      pastEventColumns={pastEventColumns}
      pageTitle={pageTitle}
      currentEventsOfOrganiser={currentEventsOfOrganiser}
      pastEventsOfOrganiser={pastEventsOfOrganiser}
      dimensions={dimensions}
      tabHeight={tabHeight}
      userContentHeight={userContentHeight}
      tabHeaderHeight={tabHeaderHeight}
      breadcrumbHeight={breadcrumbHeight}
      loaderHtml={loaderHtml}
      loading={loading}
      tableContainerRef={tableContainerRef}
      noDataFound={"noDataFound"}
      noDataTitle={t("NO_REPORT_FOUND")}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_REPORTS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      openExportModal={openExportModal}
      showDeleteUserModal={showDeleteUserModal}
      openDeleteUserModal={(e, item) => {
        openDeleteUserModal(e, item);
      }}
      closeDeleteUserModal={closeDeleteUserModal}
      onDeleteUser={onDeleteUser}
      state={state}
      downloadUserValue={downloadUserValue}
      onCheckAction={(e, organiser) => onCheckAction(e, organiser)}
      showStatusModal={showStatusModal}
      isCheckSwitch={isCheckSwitch}
      onProcced={(e, item) => onProcced(e, item)}
      clearSearchButton={clearSearchButton}
      editUserFun={() => {
        editUserFun();
      }}
      closeDeactiveModal={closeDeactivateModal}
      onTableFilterChange={onTableFilterChange}
      searchValue={searchValue}
      searchFilterClear={searchFilterClear}
      placeHolderShimer={placeHolder}
      openviewTicketModal={openviewTicketModal}
      closeViewTicketModal={closeViewTicketModal}
      showViewTicketModal={showViewTicketModal}
      organiser={organiser}
    />
  );
};
export default OrganiserDetailsContainer;
